import React, { useEffect, useState } from "react";
import { formatDate, ToastMain ,SweetAlertShow} from "../master/Master";
import { ReceiptInfo } from "../../api/StudentServices";
import { useLocation } from "react-router-dom";
import "./FeeRecipet.css";
import { HostelReceipt } from "../../api/HostelService";

export default function HostelFeeReceipt() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get("id");

  const [loading, setLoading] = useState(false);
  const [Details, setDetails] = useState("");

  const instituteData = JSON.parse(localStorage.getItem("setting")) || {};

  const getReceiptDetail = async () => {
    setLoading(true);
    try {
      const response = await HostelReceipt(id);
      if (response?.data) {
        setDetails(response?.data);
      } else {
        // ToastMain.fire({
        //   icon: "info",
        //   title: response?.data?.message || "Something Want Wrong!",
        // });

        SweetAlertShow('info','Warning',response?.data?.message)
      }
    } catch (error) {
      // ToastMain.fire({
      //   icon: "error",
      //   title:
      //     error?.response?.data?.message ||
      //     error?.response?.message ||
      //     "Something Want Wrong!",
      // });

      SweetAlertShow('error','Error',error?.response?.data?.message ??  error?.response?.message  ?? error?.message)
    } finally {
      setLoading(false);
    }
  };

  const convertNumberToWords = (amount) => {
    if (!amount) return "";
    const words = require("number-to-words");
    return words.toWords(amount).replace(/\b\w/g, (c) => c.toUpperCase());
  };

  useEffect(() => {
    getReceiptDetail(id);
  }, []);

  return (
    <>
      <div className="FeeRecipet container-fluid my-4">
        <div
          className="row d-flex justify-content-center align-items-start"
          style={{ minHeight: "100vh" }}
        >
          {["Student", "Office"]?.map((type) => (
            <div className="col-lg-6 mb-1">
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-6">
                      <span>{type} Copy</span>
                    </div>
                    <div className="col-6 text-end">
                      {instituteData.gst_status === "YES" && (
                        <span> GST No: {instituteData.gst_no} </span>
                      )}
                    </div>

                    <div className="col-12 text-center mb-2">
                      <h4 className="text-primary m-0">
                        {Details?.school?.name}
                      </h4>
                      <h6 className="m-0">
                        {Details?.school?.village}{" "}
                        {Details?.school?.district} {Details?.school?.state}
                      </h6>
                      <h6 className="m-0">
                        {Details?.school?.email
                          ? ` Email:  ${Details?.school?.email} |`
                          : ""}
                        {Details?.school?.mobile
                          ? ` Mobile No:  ${Details?.school?.mobile}`
                          : ""}
                      </h6>
                      <h5 className="mt-1 m-0 text-dark text-uppercase fw-semibold">
                        Hostel Fee Receipt
                      </h5>
                    </div>
                    <div className="col-12 student_details mb-2">
                      <div className="row mb-2">
                        <div className="col-3">Receipt No</div>
                        <div className="col-3 fw-bold">
                          : REC-{Details?.data?.id || "0000"}
                        </div>
                        <div className="col-2">Date</div>
                        <div className="col-4 fw-bold">
                          : {formatDate(Details?.data?.payment_date)}
                        </div>
                      </div>

                      <div className="row mb-2">
                        <div className="col-3">Student Name</div>
                        <div className="col-3 fw-bold">
                          : {Details?.data?.hostel_student?.student_name} (
                          {Details?.data?.hostel_student?.registration_no})
                        </div>
                        <div className="col-2">Hostel</div>
                        <div className="col-4 fw-bold truncate-text ">
                          : {Details?.data?.hostel?.name}
                        </div>
                      </div>

                      <div className="row mb-2">
                        <div className="col-3">Father's Name</div>
                        <div className="col-3 fw-bold">
                          : {Details?.data?.hostel_student?.father_name}
                        </div>
                        <div className="col-2">Mobile</div>
                        <div className="col-4 fw-bold">
                          : {Details?.data?.hostel_student?.mobile}
                        </div>
                      </div>
                    </div>
                    <div className="col-12 mb-2">
                      <table className="table table-sm table-bordered  text-center">
                        <thead>
                          <tr>
                            <th>Month</th>
                            <th>Tran Id</th>
                            <th>Amount (₹)</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Details?.data && (
                            <tr>
                              <td>{Details?.data?.hostel_fees?.month ?? ""}</td>
                              <td>{Details?.data?.transaction_no}</td>
                              <td>{Details?.data?.amount || 0}</td>
                            </tr>
                          )}
                          <tr className="fw-bold bg-light">
                            <td colSpan={2} className="text-start">
                              Total
                            </td>
                            <td className="text-end text-primary">
                              ₹ {Details?.data?.amount || 0}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className="col-12 mb-2">
                      <div className="row mb-1">
                        <div className="col-4">Amount in Words</div>
                        <div className="col-8 fw-bold">
                          : {convertNumberToWords(Details?.data?.amount || 0)}{" "}
                          Only
                        </div>
                      </div>
                      <div className="row mb-1">
                        <div className="col-4">Payment Mode</div>
                        <div className="col-8 fw-bold">
                          : {Details?.data?.method}
                        </div>
                      </div>
                      {Details?.data?.remark && (
                        <div className="row mb-1">
                          <div className="col-4">Description</div>
                          <div className="col-8 fw-bold">
                            : {Details?.data?.remark}
                          </div>
                        </div>
                      )}

                      <div className="row mb-1">
                        <div className="col-4">Please note</div>
                        <div className="col-8 text-danger fw-bold">
                          : Fees paid are non-refundable.
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-6">Receiver's Signature</div>
                        <div className="col-6 text-end">
                          Principal / Accountant
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
